import { combineActions, createActions, handleActions } from 'redux-actions';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import { loginFacebook, loginGoogle, logout, updateSettings, fetchLocalSettings, saveLocalSettings } from 'lib/api';

// State
const defaultState = {
  details: {},
  settings: {
    allowActions: false,
    format: 'columns',
    incrementType: 'blockCount',
    sort: 'balanceLowest',
    specificity: 15,
  },
  loading: false,
  loggedIn: false,
};

// Selectors
export const selectors = {
  user: state => state.user.details,
  settings: state => state.user.settings,
  isLoggedIn: state => state.user.loggedIn,
  loading: state => state.user.loading,
};

// Actions
export const actions = createActions(
  'USER_AUTHENTICATED',
  'USER_UNAUTHENTICATED',
  'USER_RESET',
  'LOGIN_FACEBOOK',
  'LOGIN_GOOGLE',
  'LOGIN_SUCCESS',
  'LOGOUT',
  'LOADED_SETTINGS',
  'REPLACE_SETTINGS',
  'UPDATE_SETTINGS',
  'UPSERT_SETTING'
);

// Sagas
export function* loginFacebookSaga() {
  try {
    const { user } = yield call(loginFacebook);
    yield put(actions.loginSuccess(user));
  } catch (e) {
    // yield put(actions.loginGoogleResponse(e));
  }
}

export function* loginGoogleSaga() {
  try {
    const { user } = yield call(loginGoogle);
    yield put(actions.loginSuccess(user));
  } catch (e) {}
}

export function* logoutSaga() {
  try {
    yield call(logout);
    yield put(actions.logoutSuccess());
  } catch (e) {}
}

export function* updateSettingsSaga({ payload: settings }) {
  try {
    const isLoggedIn = yield select(selectors.isLoggedIn);

    if (isLoggedIn) {
      yield call(updateSettings, settings);
    } else {
      const settingsSave = yield call(saveLocalSettings, settings);
      yield put(actions.replaceSettings(settingsSave));
    }
  } catch (e) {}
}

export function* fetchLocalSettingsSaga() {
  try {
    const settings = yield call(fetchLocalSettings, defaultState.settings);
    yield put(actions.replaceSettings(settings));
  } catch (e) {
    console.log(e);
  }
}

export function* userSaga() {
  yield all([
    takeEvery(actions.loginFacebook, loginFacebookSaga),
    takeEvery(actions.loginGoogle, loginGoogleSaga),
    takeEvery(actions.logout, logoutSaga),
    takeEvery(actions.updateSettings, updateSettingsSaga),
    takeEvery(actions.userUnauthenticated, fetchLocalSettingsSaga),
  ]);
}

// Normalizers
const normalizeSetting = setting => setting;

// Reducer
export default handleActions(
  {
    [actions.removeSetting](state) {
      return {
        ...state,
        settings: defaultState.settings,
      };
    },

    // Firebase
    [actions.loadedSettings](state, { payload: settingHash }) {
      if (!settingHash) return { ...state, loading: false };

      const settingsValues = Object.keys(settingHash).map(id => normalizeSetting({ id, ...settingHash[id] }))[0];
      const settings = settingsValues ? { ...defaultState.settings, ...settingsValues } : defaultState.settings;
      return { ...state, settings, loading: false };
    },
    [actions.upsertSetting](state, { payload: settings }) {
      return { ...state, settings };
    },

    // Local Settings
    [actions.replaceSettings](state, { payload: settings }) {
      return { ...state, settings, loading: false };
    },

    // Auth Change
    [combineActions(actions.loginSuccess, actions.userAuthenticated)](
      state,
      {
        payload: { displayName, email, photoURL: fallbackPhoto, providerData },
      }
    ) {
      const [userData] = providerData;
      const photoURL = userData ? userData.photoURL : fallbackPhoto;
      return {
        ...state,
        details: { displayName, email, photoURL },
        loggedIn: true,
        loading: false,
      };
    },
    [actions.userUnauthenticated](state) {
      return {
        ...defaultState,
        loading: false,
      };
    },
    [actions.logoutSuccess](state) {
      return {
        ...defaultState,
        loading: false,
      };
    },
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/modules/user.js